import React from "react";
import FormSelect from "../../../../components/UI/formSelect/formSelect";
import Input from "../../../../components/UI/input/GgInput";
import { AddIcon } from "../../../../assets/icons";
import FileButton from "../../../../components/UI/button/FileButton";
import { IContent, ILoanBlock, IPMBlock } from "../../../../models/IPages";
import { getImageExtensionFromBase64 } from "../../../../utils";

function LoanBlock({ data, setData, categoryType, actionData }: IPMBlock) {
  const handleGuideBlock = (val: string, type: keyof ILoanBlock) =>
  setData((prev: any) => {
      if (type === "image") {
        const ext = getImageExtensionFromBase64(val);
        return {
          ...prev,
          [type]: `/image/page-management/${categoryType}/loanBlock1.${ext || "jpeg"
            }`,
          images: [val],
        };
      }
      return { ...prev, [type]: val };
    });
  return (
    <>
      <div className="title">{"Loan Block"}</div>
      <div className="step-list">
          <div className="step-item">
            <div className="inputs-container">
              <Input
                type="text"
                placeholder="Enter title"
                label="Title"
                value={data?.title}
                onChange={(val) => handleGuideBlock(val, "title")}
                disabled={!actionData?.edit}
              />
            </div>
          </div>
          <div className="step-item">
            <Input
              type="text"
              placeholder="Loan Link"
              label="Link"
              value={data?.link}
              onChange={(val) => handleGuideBlock(val, "link")}
              disabled={!actionData?.edit}
            />
          </div>
        </div>
      <div className="step-list col">
        <div className="step-item">
          <div>Center Image</div>
          <FileButton
            index={"team-loanBlock"}
            icon={{
              leftIcon: <AddIcon size="18" className="icon" />,
            }}
            value={data?.image}
            stylesType="border"
            onChange={(val) => handleGuideBlock(val, "image")}
            className="cover-image-button"
            disabled={!actionData?.edit}
          />
        </div>  
      </div>
      <div className="step-list">
          <div className="step-item">
            <div className="inputs-container">
              <Input
                type="text"
                placeholder="Enter Interest rate"
                label="Interest rate"
                value={data?.iRate}
                onChange={(val) => handleGuideBlock(val, "iRate")}
                disabled={!actionData?.edit}
              />
            </div>
          </div>
          <div className="step-item">
            <div className="inputs-container">
              <Input
                type="text"
                placeholder="Enter Comparsion
                rate"
                label="Comparsion
                rate"
                value={data?.cRate}
                onChange={(val) => handleGuideBlock(val, "cRate")}
                disabled={!actionData?.edit}
              />
            </div>
          </div>
        </div>
      
    </>
  );
}

export default LoanBlock;
